// extracted by mini-css-extract-plugin
export default {"title":"title__hbaTYl","cards":"cards__Z5LpUu","plans":"plans__nkkPDn"};